import { createFileRoute } from '@tanstack/react-router'
import { UnsubscribePage } from 'features/emailUnsubscribe'

import { unsubscribeSchema } from './unsubscribe'

export const Route = createFileRoute('/unsubscribe/')({
  component: UnsubscribePage,
  validateSearch: unsubscribeSchema,
})
